/**
 * Created by Daniel on 08/02/2021. Trigger the event when click outsdie the container
 * ------ maintenance history ------
 */

import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

export const WHITE_TAG_NAME_LIST = ['KENDO-POPUP'];
export const WHITE_CLASS_NAME = 'ignore-by-clickoutside';

@Directive({
    selector: '[clickOutside]',
})
export class ClickOutsideDirective {

    @Output() clickOutside = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) { }

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        const isIncludeKendoCalendar = document.querySelector('.k-calendar');
        const isClickGridCell = (target.getAttribute('role') || (target.parentElement && target.parentElement.getAttribute('role'))) === 'gridcell';
        const isFlyEntity = document.querySelector('.fly-entity-tag');
        // handle scenario of open dialog for entity control from slide-sheet
        const isKendoDialog = document.querySelector('.template-dialog-body');
        // handle scenario workflow include rich editor
        // handle insert image always create a new target name and include quickInsertImage.
        const isRichEditor = target && target.name && target.name.indexOf('quickInsertImage') > -1 && target.type && target.type === 'file';
        // Need to exclude the node which is popuped by the current container. So far, Kendo-popup is the only control that needs to be handled.
        // After setting [popupSettings]="{appendTo: 'component'}" for the kendo control, the node can be attached to the current component. but the element which was clicked can't be found. Need to be handled using below way.
        const rootNodeByTarget = target.getRootNode();
        // There're some elements need to be ignored by this directive, which must be flaged by adding white class.
        // For some elements, the value of the className may not be a string.
        const isElmInWhiteListNotEmitEvent = target.classList && 'contains' in target.classList && target.classList.contains(WHITE_CLASS_NAME);
        if (!WHITE_TAG_NAME_LIST.includes(rootNodeByTarget.tagName) && !isIncludeKendoCalendar && !isClickGridCell && !isFlyEntity && !isKendoDialog && !isRichEditor) {
            if (!clickedInside && !isElmInWhiteListNotEmitEvent) {
                this.clickOutside.emit(target);
            }
        }
    }
}
